var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Group_15142",
    "data-name": "Group 15142",
    width: 249.064,
    height: 254.344,
    viewBox: "0 0 249.064 254.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.031,
    y1: 0.015,
    x2: 0.949,
    y2: 0.978,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.051
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5453",
    "data-name": "Rectangle 5453",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4.92,181.563.078a15.835,15.835,0,0,1,6.211,1.3,20.806,20.806,0,0,1,5.64,3.585,23.711,23.711,0,0,1,4.489,5.333,22.635,22.635,0,0,1,2.753,6.566L244.54,199.419a22.86,22.86,0,0,1,.564,7.5,18.733,18.733,0,0,1-1.823,6.558,14.572,14.572,0,0,1-3.9,4.924,12.5,12.5,0,0,1-5.66,2.571l-166.8,29.773a18.774,18.774,0,0,1-8.093-.338,20.811,20.811,0,0,1-7.284-3.583,23.006,23.006,0,0,1-5.644-6.243,24.062,24.062,0,0,1-3.178-8.275L3.585,20.424a18.188,18.188,0,0,1,.146-7.6,15.481,15.481,0,0,1,3.055-6.2,15.165,15.165,0,0,1,5.407-4.166A17.343,17.343,0,0,1,19.4.92Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 233.2704620361328 219.0624694824219 C 234.2028656005859 218.8975067138672 235.0935211181641 218.6234130859375 235.9336090087891 218.2473907470703 C 236.7724761962891 217.8719635009766 237.5609130859375 217.3949279785156 238.2902374267578 216.8234252929688 C 239.0184478759766 216.2528076171875 239.6877136230469 215.5880279541016 240.2894287109375 214.8360900878906 C 240.8902282714844 214.0853271484375 241.4237060546875 213.2476959228516 241.8813018798828 212.3302001953125 C 242.3382263183594 211.4140319824219 242.7059173583984 210.4455108642578 242.9833068847656 209.4376068115234 C 243.2603912353516 208.4309692382812 243.4475402832031 207.3849029541016 243.5437622070312 206.3122100830078 C 243.639892578125 205.2406921386719 243.6453399658203 204.1423950195312 243.5590362548828 203.0300750732422 C 243.4728088378906 201.9187316894531 243.2950134277344 200.7931213378906 243.0245666503906 199.6659698486328 L 199.1651458740234 16.88690376281738 C 198.9206237792969 15.86792087554932 198.5925903320312 14.8661994934082 198.1876373291016 13.89246940612793 C 197.7828063964844 12.91902160644531 197.301025390625 11.97327327728271 196.7488555908203 11.06596279144287 C 196.1967010498047 10.15865993499756 195.573974609375 9.289539337158203 194.8872680664062 8.469379425048828 C 194.2003479003906 7.648989677429199 193.4491729736328 6.877354621887207 192.6402587890625 6.165296077728271 C 191.8308410644531 5.452844142913818 190.9876403808594 4.821175098419189 190.1212463378906 4.274727344512939 C 189.2541656494141 3.727843761444092 188.3636932373047 3.266194105148315 187.4605712890625 2.894310474395752 C 186.5565338134766 2.522048473358154 185.6396179199219 2.23965859413147 184.7206115722656 2.051753282546997 C 183.8005065917969 1.863620162010193 182.8781127929688 1.770166635513306 181.9643249511719 1.776078581809998 L 19.76532173156738 2.825460910797119 C 18.61297988891602 2.832916259765625 17.4973201751709 2.95202374458313 16.4299144744873 3.177822113037109 C 15.36078834533691 3.40398383140564 14.34002113342285 3.737189531326294 13.37930679321289 4.172453880310059 C 12.41702175140381 4.608429908752441 11.51498031616211 5.146801471710205 10.68499183654785 5.78253173828125 C 9.853657722473145 6.419293403625488 9.094637870788574 7.153708457946777 8.419838905334473 7.980669975280762 C 7.743989944458008 8.808933258056641 7.172950267791748 9.70512580871582 6.70995044708252 10.65663814544678 C 6.246310710906982 11.60946750640869 5.891103267669678 12.61758232116699 5.647534370422363 13.66824817657471 C 5.403679847717285 14.72014713287354 5.271780014038086 15.81445407867432 5.254984378814697 16.93832397460938 C 5.238173007965088 18.06323623657227 5.336684703826904 19.21747779846191 5.5535888671875 20.38808441162109 L 44.76020050048828 231.9811248779297 C 45.00384140014648 233.2960205078125 45.36277008056641 234.5725860595703 45.828857421875 235.7970428466797 C 46.29511260986328 237.02197265625 46.86845016479492 238.1943969726562 47.54063415527344 239.3006134033203 C 48.21282958984375 240.4068756103516 48.98363876342773 241.4465179443359 49.8447265625 242.4059906005859 C 50.70552825927734 243.3651428222656 51.65625381469727 244.2438659667969 52.6884765625 245.0286102294922 C 53.72000503540039 245.8127899169922 54.80173110961914 246.4794464111328 55.91916656494141 247.0249633789062 C 57.03550720214844 247.5699310302734 58.18717193603516 247.9938049316406 59.35973358154297 248.2931060791016 C 60.53084564208984 248.5920257568359 61.72251510620117 248.7666320800781 62.92037582397461 248.8134613037109 C 64.11650085449219 248.8602600097656 65.31855773925781 248.7797088623047 66.51230621337891 248.5684814453125 L 233.2704620361328 219.0624694824219 M 233.7226257324219 220.9773864746094 L 66.92742156982422 250.7506866455078 C 64.18118286132812 251.2408905029297 61.43943023681641 251.0963134765625 58.83395767211914 250.4124908447266 C 56.22138214111328 249.7267913818359 53.74892044067383 248.499755859375 51.54961776733398 246.8297271728516 C 49.34709548950195 245.1571960449219 47.42153167724609 243.0426635742188 45.90603637695312 240.5872039794922 C 44.39051055908203 238.1316833496094 43.28738021850586 235.3389739990234 42.72824478149414 232.3123168945312 L 3.584543466567993 20.42369079589844 C 3.087283134460449 17.73197364807129 3.165302276611328 15.16341590881348 3.730561256408691 12.82557392120361 C 4.294335842132568 10.49386787414551 5.342281341552734 8.393795013427734 6.786045074462891 6.63005542755127 C 8.225000381469727 4.872189998626709 10.05640888214111 3.449316740036011 12.19303321838379 2.46356201171875 C 14.32189559936523 1.481388211250305 16.7535228729248 0.9332717657089233 19.40276145935059 0.9195239543914795 L 181.5633544921875 0.07801039516925812 C 183.6604309082031 0.06712785363197327 185.7644653320312 0.5303195714950562 187.7743225097656 1.375771641731262 C 189.7796478271484 2.219327211380005 191.6931915283203 3.44425630569458 193.4146575927734 4.960649967193604 C 195.1340026855469 6.475230693817139 196.6636810302734 8.282269477844238 197.9034118652344 10.2934684753418 C 199.1430969238281 12.30464458465576 200.0944366455078 14.52250194549561 200.6563110351562 16.85993957519531 L 244.5398712158203 199.4189758300781 C 245.1618041992188 202.0062561035156 245.3312530517578 204.5452270507812 245.1042175292969 206.9234161376953 C 244.8766021728516 209.3073272705078 244.2503814697266 211.5317535400391 243.2809906005859 213.4816589355469 C 242.3085327148438 215.4375610351562 240.9902648925781 217.1182098388672 239.3822021484375 218.4061126708984 C 237.7686004638672 219.6983642578125 235.8629608154297 220.5953063964844 233.7226257324219 220.9773864746094 Z",
    stroke: "none",
    fill: "rgba(255,255,255,0.6)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Landing_Illustrations-03",
    "data-name": "Landing Illustrations-03",
    transform: "translate(84.142 28.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14867",
    "data-name": "Group 14867",
    transform: "translate(1.106 48.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14866",
    "data-name": "Group 14866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14865",
    "data-name": "Group 14865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46654",
    "data-name": "Path 46654",
    d: "M90.537,120.426,34.3,129.035a8.032,8.032,0,0,1-3.491-.247,9.383,9.383,0,0,1-3.157-1.653,10.734,10.734,0,0,1-2.474-2.794,11.282,11.282,0,0,1-1.446-3.662L1.854,13.52A9.349,9.349,0,0,1,1.8,9.933a7.762,7.762,0,0,1,1.229-3A6.937,6.937,0,0,1,5.321,4.829a7.238,7.238,0,0,1,3.138-.911L63.981.478a7.748,7.748,0,0,1,3.169.49,9.672,9.672,0,0,1,2.864,1.691,10.994,10.994,0,0,1,2.26,2.632A10.882,10.882,0,0,1,73.63,8.61L96.409,110.171a10.48,10.48,0,0,1,.128,3.6A8.917,8.917,0,0,1,95.49,116.9a7.314,7.314,0,0,1-2.055,2.334A6.6,6.6,0,0,1,90.537,120.426Z",
    fill: "#95b8d1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14869",
    "data-name": "Group 14869",
    transform: "translate(0.335 47.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14868",
    "data-name": "Group 14868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46655",
    "data-name": "Path 46655",
    d: "M91.483,121.886,35.244,130.53a8.655,8.655,0,0,1-3.757-.261,10.048,10.048,0,0,1-3.392-1.773,11.5,11.5,0,0,1-2.657-3,12.163,12.163,0,0,1-1.553-3.942L1.991,14.238a10.081,10.081,0,0,1-.061-3.86,8.315,8.315,0,0,1,1.32-3.222A7.431,7.431,0,0,1,5.715,4.9a7.806,7.806,0,0,1,3.378-.976L64.609.509a8.351,8.351,0,0,1,3.408.525,10.359,10.359,0,0,1,3.075,1.814,11.83,11.83,0,0,1,3.881,6.4l12.613,56.2a.88.88,0,0,1,.017.283.712.712,0,0,1-.075.257.546.546,0,0,1-.168.195.554.554,0,0,1-.262.1.749.749,0,0,1-.288-.021.654.654,0,0,1-.241-.126.787.787,0,0,1-.183-.224,1.155,1.155,0,0,1-.116-.313L73.666,9.335a9.787,9.787,0,0,0-1.243-3.016,10.213,10.213,0,0,0-2.081-2.411,9,9,0,0,0-2.627-1.559,6.979,6.979,0,0,0-2.882-.455L9.389,5.358A6.4,6.4,0,0,0,4.445,8.14,7.206,7.206,0,0,0,3.31,10.888a8.391,8.391,0,0,0,.04,3.257l21.912,107.2a10.14,10.14,0,0,0,1.325,3.322,9.969,9.969,0,0,0,2.275,2.556,8.731,8.731,0,0,0,2.892,1.526,7.228,7.228,0,0,0,3.173.239L91.24,120.4a.627.627,0,0,1,.258.016.741.741,0,0,1,.249.122.843.843,0,0,1,.206.224.994.994,0,0,1,.131.321,1.1,1.1,0,0,1-.033.287.762.762,0,0,1-.108.242.619.619,0,0,1-.187.178A.724.724,0,0,1,91.483,121.886Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14871",
    "data-name": "Group 14871",
    transform: "translate(9.793 68.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14870",
    "data-name": "Group 14870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46656",
    "data-name": "Path 46656",
    d: "M64.372,30.417,13.006,35.551a6.374,6.374,0,0,1-2.661-.316,7.771,7.771,0,0,1-2.414-1.342,8.642,8.642,0,0,1-1.892-2.151,8.406,8.406,0,0,1-1.1-2.737L1.46,12.047a7.324,7.324,0,0,1-.045-2.8,6.283,6.283,0,0,1,.952-2.372A5.485,5.485,0,0,1,6.557,4.43L57.737.467A5.887,5.887,0,0,1,60.2.823a7.511,7.511,0,0,1,2.244,1.311,8.587,8.587,0,0,1,1.777,2.054,8.4,8.4,0,0,1,1.063,2.591l3.609,16.167a7.457,7.457,0,0,1,.116,2.7,6.208,6.208,0,0,1-.812,2.313A5.2,5.2,0,0,1,66.6,29.636,4.933,4.933,0,0,1,64.372,30.417Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14922",
    "data-name": "Group 14922",
    transform: "translate(25.472 108.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14873",
    "data-name": "Group 14873",
    transform: "translate(0 3.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14872",
    "data-name": "Group 14872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46657",
    "data-name": "Path 46657",
    d: "M13.673,8.064,3.619,9.2a1.878,1.878,0,0,1-.8-.088,2.313,2.313,0,0,1-.726-.4,2.6,2.6,0,0,1-.571-.647,2.541,2.541,0,0,1-.332-.826L.451,3.672a2.29,2.29,0,0,1-.017-.858,2.015,2.015,0,0,1,.283-.738,1.759,1.759,0,0,1,.53-.537,1.661,1.661,0,0,1,.726-.254L12.018.208A1.849,1.849,0,0,1,12.8.3a2.3,2.3,0,0,1,.715.4,2.6,2.6,0,0,1,.563.64,2.54,2.54,0,0,1,.33.816l.746,3.53a2.3,2.3,0,0,1,.022.852,2.011,2.011,0,0,1-.273.735,1.737,1.737,0,0,1-.519.537A1.626,1.626,0,0,1,13.673,8.064Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14875",
    "data-name": "Group 14875",
    transform: "translate(18.693 1.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14874",
    "data-name": "Group 14874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46658",
    "data-name": "Path 46658",
    d: "M13.373,7.95,3.584,9.056a1.815,1.815,0,0,1-.778-.087,2.272,2.272,0,0,1-.711-.4,2.585,2.585,0,0,1-.561-.638A2.545,2.545,0,0,1,1.2,7.12L.456,3.6a2.285,2.285,0,0,1-.023-.846A1.983,1.983,0,0,1,.7,2.029,1.7,1.7,0,0,1,1.215,1.5a1.593,1.593,0,0,1,.705-.25L11.7.2a1.788,1.788,0,0,1,.767.091,2.258,2.258,0,0,1,.7.394,2.582,2.582,0,0,1,.554.632,2.544,2.544,0,0,1,.328.8L14.8,5.606a2.294,2.294,0,0,1,.028.84,1.98,1.98,0,0,1-.261.724,1.681,1.681,0,0,1-.5.528A1.559,1.559,0,0,1,13.373,7.95Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14877",
    "data-name": "Group 14877",
    transform: "translate(36.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14876",
    "data-name": "Group 14876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46659",
    "data-name": "Path 46659",
    d: "M13.083,7.84,3.55,8.917A1.755,1.755,0,0,1,2.79,8.83a2.231,2.231,0,0,1-.7-.391,2.58,2.58,0,0,1-.879-1.434L.461,3.536A2.28,2.28,0,0,1,.432,2.7a1.952,1.952,0,0,1,.258-.717,1.647,1.647,0,0,1,.5-.521,1.529,1.529,0,0,1,.685-.246L11.4.2a1.73,1.73,0,0,1,.748.091,2.219,2.219,0,0,1,.685.39A2.58,2.58,0,0,1,13.7,2.1l.76,3.434a2.1,2.1,0,0,1,.08.823,1.757,1.757,0,0,1-.233.712,1.583,1.583,0,0,1-.5.522A1.662,1.662,0,0,1,13.083,7.84Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14879",
    "data-name": "Group 14879",
    transform: "translate(2.944 17.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14878",
    "data-name": "Group 14878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46660",
    "data-name": "Path 46660",
    d: "M13.706,8.145,3.635,9.388a1.862,1.862,0,0,1-.8-.081,2.287,2.287,0,0,1-.728-.4,2.584,2.584,0,0,1-.573-.648A2.554,2.554,0,0,1,1.2,7.431L.455,3.837A2.328,2.328,0,0,1,.437,2.97a2.061,2.061,0,0,1,.282-.748,1.791,1.791,0,0,1,.531-.547,1.669,1.669,0,0,1,.727-.264L12.038.228a1.834,1.834,0,0,1,.787.084,2.274,2.274,0,0,1,.717.4,2.581,2.581,0,0,1,.565.641,2.554,2.554,0,0,1,.332.821l.752,3.557a2.337,2.337,0,0,1,.023.86,2.057,2.057,0,0,1-.273.744,1.769,1.769,0,0,1-.519.547A1.633,1.633,0,0,1,13.706,8.145Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14881",
    "data-name": "Group 14881",
    transform: "translate(21.668 15.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14880",
    "data-name": "Group 14880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46661",
    "data-name": "Path 46661",
    d: "M13.4,8.029,3.6,9.239a1.8,1.8,0,0,1-.78-.081,2.247,2.247,0,0,1-.712-.393,2.583,2.583,0,0,1-.894-1.458L.46,3.762a2.323,2.323,0,0,1-.024-.854A2.028,2.028,0,0,1,.7,2.171a1.733,1.733,0,0,1,.513-.539,1.6,1.6,0,0,1,.706-.259l9.8-1.151a1.773,1.773,0,0,1,.768.084,2.233,2.233,0,0,1,.7.391,2.582,2.582,0,0,1,.885,1.442l.759,3.508a2.331,2.331,0,0,1,.029.848,2.025,2.025,0,0,1-.26.733,1.713,1.713,0,0,1-.5.538A1.566,1.566,0,0,1,13.4,8.029Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14883",
    "data-name": "Group 14883",
    transform: "translate(39.898 13.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14882",
    "data-name": "Group 14882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46662",
    "data-name": "Path 46662",
    d: "M13.113,7.917,3.565,9.095A1.74,1.74,0,0,1,2.8,9.014a2.207,2.207,0,0,1-.7-.388,2.581,2.581,0,0,1-.882-1.439l-.761-3.5a2.318,2.318,0,0,1-.03-.842,2,2,0,0,1,.257-.726,1.678,1.678,0,0,1,.5-.53,1.535,1.535,0,0,1,.686-.254L11.413.217A1.715,1.715,0,0,1,12.162.3a2.2,2.2,0,0,1,.687.387,2.58,2.58,0,0,1,.873,1.424l.766,3.46a2.132,2.132,0,0,1,.082.83,1.8,1.8,0,0,1-.233.721,1.612,1.612,0,0,1-.5.532A1.669,1.669,0,0,1,13.113,7.917Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14885",
    "data-name": "Group 14885",
    transform: "translate(5.889 31.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14884",
    "data-name": "Group 14884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46663",
    "data-name": "Path 46663",
    d: "M13.74,8.226,3.651,9.577a1.848,1.848,0,0,1-.8-.074,2.263,2.263,0,0,1-.73-.394,2.586,2.586,0,0,1-.91-1.484L.458,4a2.368,2.368,0,0,1-.019-.875A2.108,2.108,0,0,1,.721,2.37a1.824,1.824,0,0,1,.531-.558,1.677,1.677,0,0,1,.728-.273L12.059.249a1.82,1.82,0,0,1,.789.078,2.249,2.249,0,0,1,.719.393,2.585,2.585,0,0,1,.9,1.467l.757,3.584a2.376,2.376,0,0,1,.024.868,2.1,2.1,0,0,1-.273.754,1.8,1.8,0,0,1-.519.557A1.642,1.642,0,0,1,13.74,8.226Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14887",
    "data-name": "Group 14887",
    transform: "translate(24.645 29.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14886",
    "data-name": "Group 14886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46664",
    "data-name": "Path 46664",
    d: "M13.435,8.108,3.616,9.423a1.785,1.785,0,0,1-.781-.074,2.222,2.222,0,0,1-.714-.39,2.584,2.584,0,0,1-.9-1.464L.463,3.924a2.362,2.362,0,0,1-.026-.862,2.074,2.074,0,0,1,.269-.747,1.765,1.765,0,0,1,.513-.549A1.608,1.608,0,0,1,1.927,1.5L11.738.242a1.759,1.759,0,0,1,.769.078,2.209,2.209,0,0,1,.7.388A2.582,2.582,0,0,1,14.1,2.157l.765,3.534a2.37,2.37,0,0,1,.03.855,2.07,2.07,0,0,1-.26.743,1.745,1.745,0,0,1-.5.548A1.575,1.575,0,0,1,13.435,8.108Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14889",
    "data-name": "Group 14889",
    transform: "translate(42.903 27.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14888",
    "data-name": "Group 14888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46665",
    "data-name": "Path 46665",
    d: "M13.142,7.994,3.581,9.274A1.726,1.726,0,0,1,2.819,9.2a2.184,2.184,0,0,1-.7-.385,2.548,2.548,0,0,1-.555-.632,2.577,2.577,0,0,1-.331-.813L.468,3.848A2.356,2.356,0,0,1,.436,3a2.042,2.042,0,0,1,.257-.736,1.709,1.709,0,0,1,.5-.54,1.543,1.543,0,0,1,.687-.263L11.43.237a1.7,1.7,0,0,1,.751.078A2.172,2.172,0,0,1,12.869.7a2.547,2.547,0,0,1,.548.626,2.576,2.576,0,0,1,.328.8l.771,3.486a2.164,2.164,0,0,1,.083.837,1.836,1.836,0,0,1-.232.73,1.642,1.642,0,0,1-.5.542A1.677,1.677,0,0,1,13.142,7.994Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14891",
    "data-name": "Group 14891",
    transform: "translate(8.879 46.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14890",
    "data-name": "Group 14890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46666",
    "data-name": "Path 46666",
    d: "M13.773,8.309,3.667,9.77a1.834,1.834,0,0,1-.8-.067,2.238,2.238,0,0,1-.732-.391,2.558,2.558,0,0,1-.576-.649,2.584,2.584,0,0,1-.337-.84L.462,4.172a2.408,2.408,0,0,1-.021-.883,2.156,2.156,0,0,1,.282-.768,1.86,1.86,0,0,1,.531-.568,1.687,1.687,0,0,1,.729-.283l10.1-1.4a1.805,1.805,0,0,1,.791.071,2.225,2.225,0,0,1,.72.39,2.555,2.555,0,0,1,.569.643,2.582,2.582,0,0,1,.335.83l.763,3.612a2.416,2.416,0,0,1,.025.876,2.152,2.152,0,0,1-.272.764,1.837,1.837,0,0,1-.52.567A1.651,1.651,0,0,1,13.773,8.309Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14894",
    "data-name": "Group 14894",
    transform: "translate(27.666 43.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14893",
    "data-name": "Group 14893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14892",
    "data-name": "Group 14892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46667",
    "data-name": "Path 46667",
    d: "M13.467,8.188,3.632,9.611a1.771,1.771,0,0,1-.783-.067,2.2,2.2,0,0,1-.716-.387,2.546,2.546,0,0,1-.566-.641,2.588,2.588,0,0,1-.335-.829l-.765-3.6a2.4,2.4,0,0,1-.027-.87,2.121,2.121,0,0,1,.269-.757A1.8,1.8,0,0,1,1.222,1.9a1.617,1.617,0,0,1,.708-.278L11.757.263a1.745,1.745,0,0,1,.771.071,2.185,2.185,0,0,1,.7.385,2.544,2.544,0,0,1,.559.635,2.586,2.586,0,0,1,.332.819l.771,3.561a2.41,2.41,0,0,1,.031.863,2.118,2.118,0,0,1-.259.753,1.778,1.778,0,0,1-.5.558A1.583,1.583,0,0,1,13.467,8.188Z",
    fill: "#cc745f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14896",
    "data-name": "Group 14896",
    transform: "translate(45.953 41.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14895",
    "data-name": "Group 14895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46668",
    "data-name": "Path 46668",
    d: "M13.172,8.072,3.6,9.457a1.712,1.712,0,0,1-.763-.068,2.159,2.159,0,0,1-.7-.382,2.535,2.535,0,0,1-.557-.632,2.592,2.592,0,0,1-.332-.817L.471,4.009a2.4,2.4,0,0,1-.032-.858,2.088,2.088,0,0,1,.256-.745,1.742,1.742,0,0,1,.5-.55,1.551,1.551,0,0,1,.688-.272L11.447.257A1.687,1.687,0,0,1,12.2.328a2.148,2.148,0,0,1,.69.381,2.534,2.534,0,0,1,.549.626,2.59,2.59,0,0,1,.33.808l.777,3.512a2.2,2.2,0,0,1,.084.844,1.878,1.878,0,0,1-.232.739,1.659,1.659,0,0,1-1.225.833Z",
    fill: "#0d3b66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14921",
    "data-name": "Group 14921",
    transform: "translate(1.523 1.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14898",
    "data-name": "Group 14898",
    transform: "translate(0 3.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14897",
    "data-name": "Group 14897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46669",
    "data-name": "Path 46669",
    d: "M12.316,7.665,2.261,8.806a.711.711,0,0,1-.275-.024.816.816,0,0,1-.262-.131.873.873,0,0,1-.214-.231.969.969,0,0,1-.131-.326.887.887,0,0,1-.011-.3.747.747,0,0,1,.089-.27.6.6,0,0,1,.188-.205.634.634,0,0,1,.287-.1L11.985,6.09a1.073,1.073,0,0,0,.48-.177,1.22,1.22,0,0,0,.354-.37,1.407,1.407,0,0,0,.19-.5A1.514,1.514,0,0,0,13,4.468L12.252.936a.881.881,0,0,1-.013-.293.733.733,0,0,1,.086-.266.588.588,0,0,1,.184-.2.616.616,0,0,1,.282-.1A.7.7,0,0,1,13.06.1a.81.81,0,0,1,.258.13.873.873,0,0,1,.211.229.969.969,0,0,1,.13.322l.746,3.528a4.015,4.015,0,0,1-.053,1.213,3.244,3.244,0,0,1-.4,1.036,2.431,2.431,0,0,1-.694.75A2.066,2.066,0,0,1,12.316,7.665Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14900",
    "data-name": "Group 14900",
    transform: "translate(18.662 1.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14899",
    "data-name": "Group 14899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46670",
    "data-name": "Path 46670",
    d: "M12.048,7.555,2.258,8.667a.686.686,0,0,1-.268-.024.8.8,0,0,1-.257-.129.869.869,0,0,1-.211-.228.971.971,0,0,1-.13-.322A.886.886,0,0,1,1.38,7.67.737.737,0,0,1,1.464,7.4a.586.586,0,0,1,.182-.2.608.608,0,0,1,.279-.1L11.713,6a1.029,1.029,0,0,0,.466-.173,1.181,1.181,0,0,0,.342-.364A1.385,1.385,0,0,0,12.7,4.97a1.511,1.511,0,0,0-.015-.566L11.934.921A.879.879,0,0,1,11.92.632.724.724,0,0,1,12,.37a.57.57,0,0,1,.178-.2.591.591,0,0,1,.274-.1A.674.674,0,0,1,12.716.1a.794.794,0,0,1,.252.129.868.868,0,0,1,.208.226.97.97,0,0,1,.129.318l.754,3.479a3.5,3.5,0,0,1-.007,1.192,3,3,0,0,1-.381,1.021,2.408,2.408,0,0,1-.69.741A2.05,2.05,0,0,1,12.048,7.555Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14902",
    "data-name": "Group 14902",
    transform: "translate(36.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14901",
    "data-name": "Group 14901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46671",
    "data-name": "Path 46671",
    d: "M11.789,7.449,2.255,8.531a.664.664,0,0,1-.261-.024.785.785,0,0,1-.251-.128.864.864,0,0,1-.207-.225.973.973,0,0,1-.129-.318.885.885,0,0,1-.015-.289.727.727,0,0,1,.08-.262.568.568,0,0,1,.176-.2.584.584,0,0,1,.271-.1l9.532-1.071a.988.988,0,0,0,.453-.17,1.144,1.144,0,0,0,.331-.359,1.365,1.365,0,0,0,.173-.488,1.507,1.507,0,0,0-.019-.558L11.629.907a.878.878,0,0,1-.016-.285.714.714,0,0,1,.078-.259.553.553,0,0,1,.172-.2.568.568,0,0,1,.266-.1A.651.651,0,0,1,12.385.1a.779.779,0,0,1,.247.127.863.863,0,0,1,.2.223.972.972,0,0,1,.128.314l.76,3.432a3.672,3.672,0,0,1,.014,1.174,2.894,2.894,0,0,1-.345,1,2.227,2.227,0,0,1-.664.729A2.057,2.057,0,0,1,11.789,7.449Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14904",
    "data-name": "Group 14904",
    transform: "translate(2.927 17.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14903",
    "data-name": "Group 14903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46672",
    "data-name": "Path 46672",
    d: "M12.346,7.75,2.274,9A.706.706,0,0,1,2,8.976a.807.807,0,0,1-.263-.129.868.868,0,0,1-.215-.231.975.975,0,0,1-.132-.328.9.9,0,0,1-.012-.3.764.764,0,0,1,.089-.274A.616.616,0,0,1,1.654,7.5.637.637,0,0,1,1.941,7.4L12.012,6.163a1.078,1.078,0,0,0,.48-.183,1.243,1.243,0,0,0,.354-.377,1.439,1.439,0,0,0,.19-.509,1.539,1.539,0,0,0-.012-.579L12.273.957a.9.9,0,0,1-.013-.3.75.75,0,0,1,.086-.269A.6.6,0,0,1,12.53.186a.619.619,0,0,1,.282-.1.692.692,0,0,1,.27.023.8.8,0,0,1,.259.129.867.867,0,0,1,.212.229.974.974,0,0,1,.131.324l.752,3.555a4.209,4.209,0,0,1-.043,1.267A3.145,3.145,0,0,1,14,6.656a2.386,2.386,0,0,1-.7.741A2.17,2.17,0,0,1,12.346,7.75Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14906",
    "data-name": "Group 14906",
    transform: "translate(21.621 15.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14905",
    "data-name": "Group 14905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46673",
    "data-name": "Path 46673",
    d: "M12.076,7.638,2.271,8.853A.681.681,0,0,1,2,8.831.791.791,0,0,1,1.746,8.7a.864.864,0,0,1-.211-.228A.977.977,0,0,1,1.4,8.151a.9.9,0,0,1-.014-.3.753.753,0,0,1,.084-.269.6.6,0,0,1,.182-.206.611.611,0,0,1,.279-.1l9.8-1.2a1.034,1.034,0,0,0,.467-.18,1.2,1.2,0,0,0,.342-.371,1.416,1.416,0,0,0,.181-.5,1.536,1.536,0,0,0-.016-.571L11.954.942A.893.893,0,0,1,11.939.65a.74.74,0,0,1,.082-.266.581.581,0,0,1,.178-.2.594.594,0,0,1,.274-.1A.669.669,0,0,1,12.737.1a.786.786,0,0,1,.253.127A.863.863,0,0,1,13.2.458a.975.975,0,0,1,.13.32l.759,3.505a3.7,3.7,0,0,1,0,1.244,2.918,2.918,0,0,1-.382,1.03,2.363,2.363,0,0,1-.7.732A2.152,2.152,0,0,1,12.076,7.638Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14908",
    "data-name": "Group 14908",
    transform: "translate(39.82 13.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14907",
    "data-name": "Group 14907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46674",
    "data-name": "Path 46674",
    d: "M11.816,7.529,2.268,8.712a.658.658,0,0,1-.262-.022.776.776,0,0,1-.252-.126.859.859,0,0,1-.208-.225.978.978,0,0,1-.13-.319A.9.9,0,0,1,1.4,7.728a.742.742,0,0,1,.08-.266.579.579,0,0,1,.176-.2.586.586,0,0,1,.271-.1l9.547-1.172a.993.993,0,0,0,.454-.176,1.166,1.166,0,0,0,.331-.365,1.4,1.4,0,0,0,.173-.494,1.533,1.533,0,0,0-.02-.563L11.648.927a.893.893,0,0,1-.017-.288.73.73,0,0,1,.078-.262.563.563,0,0,1,.172-.2.57.57,0,0,1,.266-.1A.646.646,0,0,1,12.4.1a.771.771,0,0,1,.248.126.858.858,0,0,1,.2.223.977.977,0,0,1,.129.316l.766,3.458a3.881,3.881,0,0,1,.025,1.225,2.817,2.817,0,0,1-.345,1.013,2.187,2.187,0,0,1-.669.72A2.161,2.161,0,0,1,11.816,7.529Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14910",
    "data-name": "Group 14910",
    transform: "translate(5.898 32.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14909",
    "data-name": "Group 14909"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46675",
    "data-name": "Path 46675",
    d: "M12.377,7.836,2.287,9.193a.7.7,0,0,1-.276-.02.8.8,0,0,1-.264-.128.864.864,0,0,1-.216-.232.98.98,0,0,1-.132-.33.917.917,0,0,1-.012-.3A.781.781,0,0,1,1.476,7.9a.629.629,0,0,1,.188-.213.641.641,0,0,1,.288-.11L12.04,6.237a1.084,1.084,0,0,0,.481-.189,1.267,1.267,0,0,0,.354-.384,1.472,1.472,0,0,0,.19-.516,1.566,1.566,0,0,0-.013-.585L12.3.978a.909.909,0,0,1-.013-.3.766.766,0,0,1,.086-.273A.611.611,0,0,1,12.552.2a.623.623,0,0,1,.282-.107A.687.687,0,0,1,13.1.112a.792.792,0,0,1,.259.128.862.862,0,0,1,.213.229A.979.979,0,0,1,13.708.8l.758,3.582a4.287,4.287,0,0,1-.041,1.28,3.218,3.218,0,0,1-.4,1.059,2.43,2.43,0,0,1-.7.755A2.18,2.18,0,0,1,12.377,7.836Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14912",
    "data-name": "Group 14912",
    transform: "translate(24.623 29.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14911",
    "data-name": "Group 14911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46676",
    "data-name": "Path 46676",
    d: "M12.105,7.722,2.284,9.043a.676.676,0,0,1-.269-.02A.783.783,0,0,1,1.758,8.9a.859.859,0,0,1-.212-.229.982.982,0,0,1-.131-.326.915.915,0,0,1-.014-.3.77.77,0,0,1,.084-.273.6.6,0,0,1,.462-.317l9.819-1.309a1.04,1.04,0,0,0,.467-.186,1.226,1.226,0,0,0,.342-.378,1.449,1.449,0,0,0,.181-.508,1.561,1.561,0,0,0-.017-.576L11.974.962a.907.907,0,0,1-.015-.294A.756.756,0,0,1,12.041.4a.592.592,0,0,1,.178-.206.6.6,0,0,1,.274-.1.663.663,0,0,1,.264.021.777.777,0,0,1,.254.126.858.858,0,0,1,.209.226.981.981,0,0,1,.13.322l.765,3.532a3.764,3.764,0,0,1,.005,1.256,2.985,2.985,0,0,1-.381,1.044,2.408,2.408,0,0,1-.7.745A2.163,2.163,0,0,1,12.105,7.722Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14914",
    "data-name": "Group 14914",
    transform: "translate(42.851 27.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14913",
    "data-name": "Group 14913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46677",
    "data-name": "Path 46677",
    d: "M11.843,7.611,2.281,8.9a.653.653,0,0,1-.262-.02.768.768,0,0,1-.252-.125.854.854,0,0,1-.208-.226.983.983,0,0,1-.13-.321.913.913,0,0,1-.016-.294.759.759,0,0,1,.08-.269.575.575,0,0,1,.447-.311L11.5,6.056a1,1,0,0,0,.454-.182,1.188,1.188,0,0,0,.331-.372,1.427,1.427,0,0,0,.173-.5,1.558,1.558,0,0,0-.02-.568L11.666.947a.906.906,0,0,1-.017-.29.746.746,0,0,1,.077-.265.558.558,0,0,1,.439-.305.641.641,0,0,1,.258.021.762.762,0,0,1,.248.125.854.854,0,0,1,.205.224.983.983,0,0,1,.129.317l.772,3.483A3.947,3.947,0,0,1,13.8,5.494a2.88,2.88,0,0,1-.344,1.026,2.228,2.228,0,0,1-.669.733A2.171,2.171,0,0,1,11.843,7.611Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14916",
    "data-name": "Group 14916",
    transform: "translate(8.87 46.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14915",
    "data-name": "Group 14915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46678",
    "data-name": "Path 46678",
    d: "M12.407,7.923,2.3,9.39a.7.7,0,0,1-.276-.017.79.79,0,0,1-.264-.127.858.858,0,0,1-.217-.232.986.986,0,0,1-.133-.332A.932.932,0,0,1,1.4,8.377.8.8,0,0,1,1.486,8.1a.628.628,0,0,1,.477-.33l10.1-1.454a1.091,1.091,0,0,0,.482-.2,1.291,1.291,0,0,0,.354-.391,1.506,1.506,0,0,0,.189-.522,1.592,1.592,0,0,0-.013-.59L12.317,1A.924.924,0,0,1,12.3.7a.784.784,0,0,1,.085-.276.623.623,0,0,1,.184-.213A.626.626,0,0,1,12.856.1a.682.682,0,0,1,.271.019.784.784,0,0,1,.26.126.858.858,0,0,1,.213.23A.984.984,0,0,1,13.732.8l.763,3.61a4.365,4.365,0,0,1-.04,1.292,3.292,3.292,0,0,1-.395,1.073,2.477,2.477,0,0,1-.7.769A2.193,2.193,0,0,1,12.407,7.923Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14918",
    "data-name": "Group 14918",
    transform: "translate(27.627 43.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14917",
    "data-name": "Group 14917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46679",
    "data-name": "Path 46679",
    d: "M12.134,7.807,2.3,9.234a.671.671,0,0,1-.269-.017.774.774,0,0,1-.258-.125.854.854,0,0,1-.213-.229.987.987,0,0,1-.132-.328.93.93,0,0,1-.015-.3.788.788,0,0,1,.084-.276.6.6,0,0,1,.462-.324l9.835-1.416a1.046,1.046,0,0,0,.468-.192,1.25,1.25,0,0,0,.342-.385,1.481,1.481,0,0,0,.181-.514,1.588,1.588,0,0,0-.017-.582L11.994.983a.922.922,0,0,1-.016-.3A.773.773,0,0,1,12.06.414.587.587,0,0,1,12.512.1a.658.658,0,0,1,.265.019.768.768,0,0,1,.254.125.854.854,0,0,1,.21.227.986.986,0,0,1,.131.323l.771,3.559a3.829,3.829,0,0,1,.007,1.268,3.052,3.052,0,0,1-.38,1.057,2.453,2.453,0,0,1-.7.759A2.174,2.174,0,0,1,12.134,7.807Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14920",
    "data-name": "Group 14920",
    transform: "translate(45.883 41.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14919",
    "data-name": "Group 14919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46680",
    "data-name": "Path 46680",
    d: "M11.871,7.693,2.294,9.083a.648.648,0,0,1-.263-.018.759.759,0,0,1-.253-.124.85.85,0,0,1-.209-.226.989.989,0,0,1-.131-.323.928.928,0,0,1-.016-.3.777.777,0,0,1,.08-.272.6.6,0,0,1,.176-.21.593.593,0,0,1,.272-.109l9.575-1.378a1,1,0,0,0,.455-.188,1.211,1.211,0,0,0,.331-.379,1.459,1.459,0,0,0,.172-.507,1.583,1.583,0,0,0-.021-.573L11.684.967a.921.921,0,0,1-.017-.293.763.763,0,0,1,.077-.268A.585.585,0,0,1,11.916.2a.576.576,0,0,1,.267-.106.636.636,0,0,1,.258.019.754.754,0,0,1,.249.124A.848.848,0,0,1,12.9.46a.987.987,0,0,1,.13.319L13.8,4.288a4.015,4.015,0,0,1,.028,1.249,2.945,2.945,0,0,1-.343,1.039,2.271,2.271,0,0,1-.669.747A2.182,2.182,0,0,1,11.871,7.693Z",
    fill: "#060e12"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14924",
    "data-name": "Group 14924",
    transform: "translate(9.397 56.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14923",
    "data-name": "Group 14923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46681",
    "data-name": "Path 46681",
    d: "M59.552,2.768l.206.924a2.889,2.889,0,0,1,.048,1,2.566,2.566,0,0,1-.279.879,2.2,2.2,0,0,1-.546.67,1.9,1.9,0,0,1-.754.377l-.062,0-.062,0-.062,0-.062,0-53.9,3.9a2.692,2.692,0,0,1-1.07-.148,3.283,3.283,0,0,1-.984-.549,3.545,3.545,0,0,1-.779-.877A3.429,3.429,0,0,1,.795,7.839L.6,6.874A2.968,2.968,0,0,1,.575,5.757,2.535,2.535,0,0,1,.953,4.8a2.217,2.217,0,0,1,.723-.69A2.282,2.282,0,0,1,2.688,3.8L56.375.173l.062,0,.062,0,.062,0,.062,0a2.916,2.916,0,0,1,.99.254,3.4,3.4,0,0,1,.87.569,3.557,3.557,0,0,1,.672.81A3.275,3.275,0,0,1,59.552,2.768Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14926",
    "data-name": "Group 14926",
    transform: "translate(31.358 73.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14925",
    "data-name": "Group 14925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46682",
    "data-name": "Path 46682",
    d: "M16.035,25.58a1.531,1.531,0,0,1-.4-.015,1.867,1.867,0,0,1-.4-.116,2.193,2.193,0,0,1-.39-.21,2.429,2.429,0,0,1-.359-.3L2.812,13.533a2.588,2.588,0,0,1-.479-.679,2.42,2.42,0,0,1-.227-.757,1.972,1.972,0,0,1,.044-.743,1.574,1.574,0,0,1,.9-1.055,1.625,1.625,0,0,1,.677-.131,1.814,1.814,0,0,1,.7.16,2.118,2.118,0,0,1,.65.458l9.839,9.6L24.233.961a1.406,1.406,0,0,1,.418-.536,1.38,1.38,0,0,1,.59-.263,1.676,1.676,0,0,1,.683.017,2.113,2.113,0,0,1,.7.3,2.216,2.216,0,0,1,.57.549,2.362,2.362,0,0,1,.345.693,2.262,2.262,0,0,1,.1.749,1.922,1.922,0,0,1-.165.717l-10.3,21.493A1.235,1.235,0,0,1,17,25.03a1.269,1.269,0,0,1-.26.273,1.334,1.334,0,0,1-.328.187,1.378,1.378,0,0,1-.374.09Z",
    fill: "#0d3b66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14928",
    "data-name": "Group 14928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14927",
    "data-name": "Group 14927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46683",
    "data-name": "Path 46683",
    d: "M53.354,3.769l12.724,57.36-52.926,3.8L.81,5.309A3.845,3.845,0,0,1,.792,3.785a3.2,3.2,0,0,1,.544-1.266,2.912,2.912,0,0,1,1.007-.873A3.114,3.114,0,0,1,3.715,1.3L49.056.1a3.29,3.29,0,0,1,1.4.212,4.3,4.3,0,0,1,1.277.765,5.009,5.009,0,0,1,1.014,1.194A4.945,4.945,0,0,1,53.354,3.769Z",
    transform: "translate(0.863 0.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46684",
    "data-name": "Path 46684",
    d: "M67.085,62.508l-52.93,3.826a.739.739,0,0,1-.274-.034.856.856,0,0,1-.261-.136.894.894,0,0,1-.212-.231.948.948,0,0,1-.129-.319L.963,6.059a4.612,4.612,0,0,1-.026-1.8,3.818,3.818,0,0,1,.635-1.508A3.431,3.431,0,0,1,2.768,1.7a3.733,3.733,0,0,1,1.656-.418L49.76.107a4.271,4.271,0,0,1,1.662.306,5.445,5.445,0,0,1,1.523.918,5.975,5.975,0,0,1,1.209,1.4,5.621,5.621,0,0,1,.721,1.75L67.6,61.812a.48.48,0,0,1-.008.223.689.689,0,0,1-.1.221.656.656,0,0,1-.177.173A.486.486,0,0,1,67.085,62.508Zm-52.6,2.336,51.632-3.678L53.559,4.518a4,4,0,0,0-.487-1.2,4.169,4.169,0,0,0-.827-.983,3.719,3.719,0,0,0-1.066-.655,3.047,3.047,0,0,0-1.2-.22L4.625,2.681a2.671,2.671,0,0,0-1.139.279,2.391,2.391,0,0,0-.844.71,2.585,2.585,0,0,0-.457,1.051,3.293,3.293,0,0,0,.021,1.3L14.392,64.85Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14930",
    "data-name": "Group 14930",
    transform: "translate(8.144 7.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14929",
    "data-name": "Group 14929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5433",
    "data-name": "Rectangle 5433",
    d: "M0,1.3,41.442,0l.2.9L.194,2.235Z",
    transform: "translate(0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14932",
    "data-name": "Group 14932",
    transform: "translate(15.018 39.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14931",
    "data-name": "Group 14931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5434",
    "data-name": "Rectangle 5434",
    d: "M0,2.288,41.61,0l.2.919L.2,3.236Z",
    transform: "translate(0 0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14934",
    "data-name": "Group 14934",
    transform: "translate(18.054 53.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14933",
    "data-name": "Group 14933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5435",
    "data-name": "Rectangle 5435",
    d: "M0,2.728,41.683,0l.2.926L.2,3.683Z",
    transform: "translate(0 0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14936",
    "data-name": "Group 14936",
    transform: "translate(9.739 15.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14935",
    "data-name": "Group 14935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5436",
    "data-name": "Rectangle 5436",
    d: "M0,.649,17.577,0l.236,1.107L.234,1.77Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14938",
    "data-name": "Group 14938",
    transform: "translate(10.48 19.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14937",
    "data-name": "Group 14937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5437",
    "data-name": "Rectangle 5437",
    d: "M0,.6,15.26,0,15.5,1.111.234,1.725Z",
    transform: "translate(0 0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14940",
    "data-name": "Group 14940",
    transform: "translate(13.48 33.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14939",
    "data-name": "Group 14939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5438",
    "data-name": "Rectangle 5438",
    d: "M0,.76,15.288,0l.238,1.12L.236,1.892Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14942",
    "data-name": "Group 14942",
    transform: "translate(46.261 32.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14941",
    "data-name": "Group 14941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5439",
    "data-name": "Rectangle 5439",
    d: "M0,.429,8.625,0l.242,1.1L.241,1.534Z",
    transform: "translate(0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14944",
    "data-name": "Group 14944",
    transform: "translate(11.223 22.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14943",
    "data-name": "Group 14943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5440",
    "data-name": "Rectangle 5440",
    d: "M0,.814,19.4,0l.238,1.11-19.4.83Z",
    transform: "translate(0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14946",
    "data-name": "Group 14946",
    transform: "translate(11.987 26.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14945",
    "data-name": "Group 14945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5441",
    "data-name": "Rectangle 5441",
    d: "M0,.569,12.766,0,13,1.118.235,1.7Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14948",
    "data-name": "Group 14948",
    transform: "translate(12.732 30.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14947",
    "data-name": "Group 14947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5442",
    "data-name": "Rectangle 5442",
    d: "M0,.85,18.04,0l.238,1.115L.236,1.981Z",
    transform: "translate(0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14950",
    "data-name": "Group 14950",
    transform: "translate(42.952 15.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14949",
    "data-name": "Group 14949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5443",
    "data-name": "Rectangle 5443",
    d: "M0,.281,7.6,0l.24,1.088L.239,1.375Z",
    transform: "translate(0 0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14952",
    "data-name": "Group 14952",
    transform: "translate(45.239 18.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14951",
    "data-name": "Group 14951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5444",
    "data-name": "Rectangle 5444",
    d: "M0,.178,4.515,0l.24,1.092L.239,1.274Z",
    transform: "translate(0 0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14954",
    "data-name": "Group 14954",
    transform: "translate(16.484 47.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14953",
    "data-name": "Group 14953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5445",
    "data-name": "Rectangle 5445",
    d: "M0,.919,15.316,0l.24,1.129L.238,2.061Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14956",
    "data-name": "Group 14956",
    transform: "translate(51.366 46.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14955",
    "data-name": "Group 14955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5446",
    "data-name": "Rectangle 5446",
    d: "M0,.272,4.53,0l.244,1.109-4.53.276Z",
    transform: "translate(0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14958",
    "data-name": "Group 14958",
    transform: "translate(44.02 22.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14957",
    "data-name": "Group 14957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5447",
    "data-name": "Rectangle 5447",
    d: "M0,.356,8.448,0l.241,1.092L.239,1.456Z",
    transform: "translate(0 0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14960",
    "data-name": "Group 14960",
    transform: "translate(47.32 25.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14959",
    "data-name": "Group 14959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5448",
    "data-name": "Rectangle 5448",
    d: "M0,.157,3.514,0l.241,1.1L.24,1.257Z",
    transform: "translate(0 0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14962",
    "data-name": "Group 14962",
    transform: "translate(46.862 29.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14961",
    "data-name": "Group 14961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5449",
    "data-name": "Rectangle 5449",
    d: "M0,.286,6.027,0l.241,1.1L.241,1.389Z",
    transform: "translate(0 0)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14964",
    "data-name": "Group 14964",
    transform: "translate(8.891 68.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14963",
    "data-name": "Group 14963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46685",
    "data-name": "Path 46685",
    d: "M65.42,31.97l-51.37,5.161a7.091,7.091,0,0,1-2.937-.342,8.607,8.607,0,0,1-2.679-1.475A9.522,9.522,0,0,1,6.327,32.93,9.364,9.364,0,0,1,5.1,29.867L1.619,12.9a8.161,8.161,0,0,1-.053-3.091A6.98,6.98,0,0,1,2.61,7.176,6.071,6.071,0,0,1,7.279,4.45L58.454.52a.668.668,0,0,1,.255.032.806.806,0,0,1,.245.131.878.878,0,0,1,.2.223.957.957,0,0,1,.126.308.837.837,0,0,1,.015.277.668.668,0,0,1-.078.249.521.521,0,0,1-.171.185.56.56,0,0,1-.265.086L7.6,6a5.072,5.072,0,0,0-2.181.673A4.986,4.986,0,0,0,3.812,8.18a5.587,5.587,0,0,0-.864,2.141,6.718,6.718,0,0,0,.046,2.565L6.478,29.837a7.776,7.776,0,0,0,2.671,4.414,6.922,6.922,0,0,0,2.179,1.218,5.839,5.839,0,0,0,2.437.285l51.362-5.108a4.523,4.523,0,0,0,2.014-.694,4.65,4.65,0,0,0,1.447-1.494,5.517,5.517,0,0,0,.739-2.088,6.84,6.84,0,0,0-.11-2.478.858.858,0,0,1-.016-.28.69.69,0,0,1,.077-.253.532.532,0,0,1,.17-.19.556.556,0,0,1,.263-.091.651.651,0,0,1,.254.028.786.786,0,0,1,.244.128.868.868,0,0,1,.2.222.965.965,0,0,1,.127.31,8.6,8.6,0,0,1,.036,2.976,7.084,7.084,0,0,1-.935,2.538,5.8,5.8,0,0,1-1.765,1.833A5.455,5.455,0,0,1,65.42,31.97Z",
    fill: "#060e12"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos);
export default __webpack_public_path__ + "static/media/pos.9e56a0118cea7f2298339b7b1a24a375.svg";
export { ForwardRef as ReactComponent };